import {
  LIST_PLURALL_IMPORT_ISSUES_REQUEST,
  LIST_PLURALL_IMPORT_ISSUES_SUCCESS,
  LIST_PLURALL_IMPORT_ISSUES_ERROR,
  RESOLVE_PLURALL_UNMATCHED_REQUEST,
  RESOLVE_PLURALL_UNMATCHED_SUCCESS,
  RESOLVE_PLURALL_UNMATCHED_ERROR,
  RESOLVE_PLURALL_PROCESS_ISSUE_REQUEST,
  RESOLVE_PLURALL_PROCESS_ISSUE_SUCCESS,
  RESOLVE_PLURALL_PROCESS_ISSUE_ERROR,
} from '../actions';

export const listPlurallImportIssuesRequest = (filters) => ({
  type: LIST_PLURALL_IMPORT_ISSUES_REQUEST,
  payload: filters,
});

export const listPlurallImportIssuesSuccess = (data) => ({
  type: LIST_PLURALL_IMPORT_ISSUES_SUCCESS,
  payload: data,
});

export const listPlurallImportIssuesError = (payload) => ({
  type: LIST_PLURALL_IMPORT_ISSUES_ERROR,
  payload: typeof payload === 'string' ? { message: payload } : payload,
});

export const resolvePlurallUnmatchedRequest = (payload) => ({
  type: RESOLVE_PLURALL_UNMATCHED_REQUEST,
  payload,
});

export const resolvePlurallUnmatchedSuccess = () => ({
  type: RESOLVE_PLURALL_UNMATCHED_SUCCESS,
});

export const resolvePlurallUnmatchedError = (message) => ({
  type: RESOLVE_PLURALL_UNMATCHED_ERROR,
  payload: { message },
});

export const resolvePlurallProcessIssueRequest = (payload) => ({
  type: RESOLVE_PLURALL_PROCESS_ISSUE_REQUEST,
  payload,
});

export const resolvePlurallProcessIssueSuccess = () => ({
  type: RESOLVE_PLURALL_PROCESS_ISSUE_SUCCESS,
});

export const resolvePlurallProcessIssueError = (message) => ({
  type: RESOLVE_PLURALL_PROCESS_ISSUE_ERROR,
  payload: { message },
});
